import type CalendarFolderSearchScope from '../schema/CalendarFolderSearchScope';
import { action } from 'satcheljs';
import type { RefinerType } from '../schema/RefinerType';
import type { OwaDate } from 'owa-datetime';

/**
 * resets search store properties to default store properties
 */
export let resetSearchStore = action('resetSearchStore');

/**
 * increments the search number
 */
export let incrementSearchNumber = action('incrementSearchNumber');

/**
 * initializes search datapoint
 */
export let initSearchDatapoint = action('initSearchDatapoint', (queryLength: number) => ({
    queryLength,
}));

/**
 * Toggle flag to determine whether or not search refiners should be shown or not
 */
export let toggleRefinersVisible = action('toggleRefinersVisible');

/**
 * Action to set the 'from' date
 */
export let setFromDate = action('setFromDate', (fromDate: OwaDate) => ({
    fromDate,
}));

/**
 * Action to set the 'to' date
 */
export let setToDate = action('setToDate', (toDate: OwaDate) => ({
    toDate,
}));

/**
 * Dispatched when "Clear filters" button is clicked in SearchRefiners component.
 */
export let onClearRefinersButtonClicked = action('onClearRefinersButtonClicked');

/**
 * Dispatched when refiner store values should be reset.
 */
export let clearRefiners = action('clearRefiners');

/**
 * Dispatched after a refiner is changed.
 */
export let onRefinerChanged = action('onRefinerChanged', (refinerType: RefinerType) => ({
    refinerType,
}));

/**
 * Dispatched when user toggles the setting 'Attachments'
 */
export let setIncludeAttachments = action(
    'setIncludeAttachments',
    (includeAttachments: boolean) => ({
        includeAttachments,
    })
);

/**
 * Dispatched when auto scroll happens
 */
export let setIsAutoScroll = action('setIsAutoScroll', (isAutoScroll: boolean) => ({
    isAutoScroll,
}));

/**
 * Dispatched when a search session is started or when user selects/deselects the calendar folder scope
 */
export let setCalendarFoldersScope = action(
    'setCalendarFoldersScope',
    (scope: CalendarFolderSearchScope) => ({
        scope,
    })
);

/**
 * Dispatched when a search session is started or when user selects/deselects the account scope
 */
export let setAccountScope = action(
    'setAccountScope',
    (initializeAccountScope: boolean, account: string) => ({
        initializeAccountScope,
        account,
    })
);

/**
 * Dispatched when not supported calendars notification is either populated or dismissed.
 */
export let setNonSearchableCalendarsText = action(
    'setNonSearchableCalendarsText',
    (dismissNotification: boolean) => ({
        dismissNotification,
    })
);
